import { AuthProvidersTypes } from "@app/shared/models/AuthProviders";

export class StringConstants {
  public readonly ADD_FILE = "ADD_FILE";
  public readonly LAGUAGES_CODE = [
    "ar",
    "cy",
    "de",
    "el",
    "en",
    "es",
    "fil",
    "fr",
    "ga",
    "he",
    "hi",
    "it",
    "ja",
    "ko",
    "nl",
    "pl",
    "pt",
    "ru",
    "sv",
    "th",
    "uk",
    "zh-hk",
    "zh",
  ];
  public readonly LAGUAGES_CODE_NAMES = {
    ar: { title: "العربية", subTitle: "Arabic" },
    cy: { title: "Cymraeg", subTitle: "Welsh" },
    de: { title: "Deutsch", subTitle: "German" },
    el: { title: "Ελληνικά", subTitle: "Greek" },
    en: { title: "English", subTitle: "English" },
    es: { title: "Española", subTitle: "Spanish" },
    fil: { title: "Filipino", subTitle: "Filipino" },
    fr: { title: "Français", subTitle: "French" },
    ga: { title: "Gaeilge", subTitle: "Irish" },
    he: { title: "עִברִית", subTitle: "Hebrew" },
    hi: { title: "हिन्दी", subTitle: "Hindi" },
    it: { title: "Italiana", subTitle: "Italian" },
    ja: { title: "日本", subTitle: "Japanese" },
    ko: { title: "한국인", subTitle: "Korean" },
    nl: { title: "Nederlands", subTitle: "Dutch" },
    pl: { title: "Polski", subTitle: "Polish" },
    pt: { title: "Português", subTitle: "Portuguese" },
    ru: { title: "Русский", subTitle: "Russian" },
    sv: { title: "svenska", subTitle: "Swedish" },
    th: { title: "ไทย", subTitle: "Thai" },
    uk: { title: "українська", subTitle: "Ukrainian" },
    "zh-hk": { title: "中國傳統的）", subTitle: "Chinese (Traditional)" },
    zh: { title: "简体中文）", subTitle: "Chinese (Simplified)" },
  };
  public readonly SYSTEM_LANG = "System Language";
  public readonly AUTH_PROVIDERS_WITH_BARCODE_TEXT = [
    AuthProvidersTypes.sirsi.toLowerCase(),
    AuthProvidersTypes.polaris.toLowerCase(),
    AuthProvidersTypes.innovative.toLowerCase(),
    AuthProvidersTypes.sirsiWeb.toLowerCase(),
    AuthProvidersTypes.polarisWeb.toLowerCase(),
  ];
  public readonly DEFAULT_SUPPORTED_LANG = {
    "_id": "64510781bf538fcb3741d1f4",
    "language": "English",
    "locale": "en",
    "flagLang": "us",
    "currency": "USD",
    "date": "en-US",
    "currencySymbol": "$"
  };
}

export const MAP_DISTANCE_MILES = [
  { label: "1", value: 1 },
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "25", value: 25 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
]